// Llamadas a las Edge Functions de IA de Leads (extract-lead, lead-profile). La clave de la IA vive solo en
// Supabase; desde aquí se manda la sesión del usuario y la función comprueba permisos, PIN y límites.

export async function invokeFn(supabase, name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (!error) return { data, error: '' };
  let msg = 'No se ha podido conectar con la IA.';
  try {
    const j = await error.context.json();
    if (j && j.error) msg = j.error;
  } catch (e) { /* respuesta sin JSON */ }
  return { data: null, error: msg };
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).replace(/^data:[^,]*,/, ''));
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });
}

export const AI_FILE_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp', 'image/gif'];
export const AI_MAX_FILE = 8 * 1024 * 1024;

// "2026-10-27T14:02" (hora local) → Date, o null.
export function parseLocalDateTime(s) {
  const m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (!m) return null;
  const d = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
  return Number.isNaN(d.getTime()) ? null : d;
}
